import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducers';

export const Store = configureStore({ reducer });
